export const convertCamelCaseToStartString = (value: string) => {
  const firstStep = value.replace(/([A-Z])/g, ' $1');
  const result = firstStep.charAt(0).toUpperCase() + firstStep.slice(1);
  return result;
};

export const description = {
  orderToShipDaysDescription: 'Minimum days from order received to preparation (production, dispatch...)',
  prepDaysDescription: 'Maximum days from order received to preparation (production, dispatch...)',
  shipToReceiveDaysDescription: 'Minimum days from order received to delivery.',
  estDaysDescription: 'Maximum days from order received to delivery.',
};

export const TIME_COUNTDOWN_MARKER = '{TimeCountDown}';
export const PREP_START_DATE_MARKER = `{prep_min}`;
export const PREP_END_DATE_MARKER = `{prep_max}`;
export const START_DATE_MARKER = `{delivery_min}`;
export const END_DATE_MARKER = `{delivery_max}`;
export const COUNTRY = `{country}`;
export const FLAG = `{flag}`;
export const ZIPCODE = `{zipcode}`;
export const defaultVariablesColor = '#1750A6';

export const messageTemplate = [
  `Selling fast! Only ⚡<b style="color: ${defaultVariablesColor};">${TIME_COUNTDOWN_MARKER}</b> left to Get Freeship<br>Delivered by <b style="color: ${defaultVariablesColor};">${START_DATE_MARKER}-${END_DATE_MARKER}</b><br>Life-time guarantee ⭐`,
  `Discount for order within <b style="color: ${defaultVariablesColor};">${TIME_COUNTDOWN_MARKER}</b> 🔥<br>Dispatched by <b style="color: ${defaultVariablesColor};">${PREP_START_DATE_MARKER}-${PREP_END_DATE_MARKER}</b><br>Get by <b style="color: ${defaultVariablesColor};">${START_DATE_MARKER}-${END_DATE_MARKER}</b>`,
  `Estimated delivery from <b style="color: ${defaultVariablesColor};">${START_DATE_MARKER} to ${END_DATE_MARKER}</b><br>🔖 Get 10% discount voucher for next order`,
  `Delivery by <b style="color: ${defaultVariablesColor};">${START_DATE_MARKER}-${END_DATE_MARKER}</b>, customs clearance time included<br>Orders on weekends may take longer`,
  `🌏 International delivery by <b style="color: ${defaultVariablesColor};">${START_DATE_MARKER}-${END_DATE_MARKER}</b><br>👍 No extra shipping fee`,
];
export const defaultEstimatedText = {
  method: `⏰ Order today within <b style="color: ${defaultVariablesColor};">${TIME_COUNTDOWN_MARKER}</b> to get discounted price<br>🚚 Delivery from <b style="color: ${defaultVariablesColor};">${START_DATE_MARKER}</b> to <b style="color: ${defaultVariablesColor};">${END_DATE_MARKER}</b>`,
  zipcode: `⚡<b style="color: ${defaultVariablesColor};">${TIME_COUNTDOWN_MARKER}</b> left to get discounted price<br>🚚 Delivery by <b style="color: ${defaultVariablesColor};">${START_DATE_MARKER}</b>-<b style="color: ${defaultVariablesColor};">${END_DATE_MARKER}</b><br>📅 Some orders may take longer based on area conditions.`,
  country: `📍Deliver to <b style="color: ${defaultVariablesColor};">${COUNTRY}</b> <span style="color: ${defaultVariablesColor};">${FLAG}</span><br>⚡<b style="color: ${defaultVariablesColor};">${TIME_COUNTDOWN_MARKER}</b> left to get discounted price<br>🌏 International delivery by <b style="color: ${defaultVariablesColor};">${START_DATE_MARKER}</b>-<b style="color: ${defaultVariablesColor};">${END_DATE_MARKER}</b><br>👍 No extra shipping fee`,
};
export const defaultSoldOutText = `<b>Currently unavailable.</b><br>⏳ This item will be back in stock on... <br>🚚 Pre-order now for FREE delivery in 2-4 days once it’s in stock.`;

export const checkoutExtensionInfo = [
  {
    id: 0,
    title:
      'ETA Checkout Extension, built on Shopify checkout UI extension, exclusive to Shopify Plus, enables merchants to customize checkout page:',
    content: [
      `Estimated delivery date (EDD/ETA) for each shipping method, with dates changing dynamically and supports split shipment.`,
      `Product line item ETA: Show ETA on individual product lines, adjusting based on the selected shipping method.`,
      'Banner on Thank You and Order Status Pages: Include ETA information selected in checkout.',
    ],
  },
];
